<template>
  <component
    ref="innerComponent"
    :is="currentComponent"
    v-bind="$attrs"
  />
</template>

<script setup>
import { computed, ref, defineExpose } from 'vue'
import { useUiToggleStore } from '../store/uiToggleStore'
import OldReportTemplate from './Old/OldReportTemplate.vue'
import NewReportTemplate from './New/NewReportTemplate.vue'

const uiToggle = useUiToggleStore()
const innerComponent = ref(null)

const currentComponent = computed(() =>
  uiToggle.showNewUI ? NewReportTemplate : OldReportTemplate
)

defineExpose({
  // Methods - using getters/setters to allow parent components to override them if needed
  get submitEditableGridChanges() { return innerComponent.value?.submitEditableGridChanges },
  get discardEditableGridChanges() { return innerComponent.value?.discardEditableGridChanges },
  get collateRequestIDs() { return innerComponent.value?.collateRequestIDs },
  set collateRequestIDs(val) { if(innerComponent.value) innerComponent.value.collateRequestIDs = val },
  get updateSelectAllCheckboxes() { return innerComponent.value?.updateSelectAllCheckboxes },
  get bootstrap() { return innerComponent.value?.bootstrap },
  
  // Properties - using getters/setters for reactivity and writability
  get reportTransactions() { return innerComponent.value?.reportTransactions },
  get selectedReqsForBulkOps() { return innerComponent.value?.selectedReqsForBulkOps },
  set selectedReqsForBulkOps(val) { if(innerComponent.value) innerComponent.value.selectedReqsForBulkOps = val },
  get allSelectedReqs() { return innerComponent.value?.allSelectedReqs },
  set allSelectedReqs(val) { if(innerComponent.value) innerComponent.value.allSelectedReqs = val },
})
</script>
